import React from 'react';

export default function StatisticsGlassCard({ children, className, onClick, noHover, isEditMode, ...props }) {
  return (
    <div
      onClick={onClick}
      className={`
                relative w-full h-full flex flex-col bg-white overflow-hidden
                border border-gray-100/60
                rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.03)]
                transition-all duration-500 ease-out
                ${!noHover && 'hover:shadow-[0_8px_30px_rgb(0,0,0,0.08)] hover:-translate-y-1 cursor-pointer hover:border-gray-200/60'}
                ${className || ''}
            `}
      {...props}
    >
      {/* Subtle top glow */}
      <div className={`absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#354F38]/20 to-transparent opacity-0 transition-opacity duration-500 ${!noHover && 'group-hover:opacity-100'}`} />

      <div className="relative flex-1 flex flex-col h-full bg-white/40 backdrop-blur-md">
        {children}
      </div>

      {isEditMode && (
        <div className="absolute bottom-3 right-3 h-6 px-3 rounded-lg bg-[#354F38]/10 border border-[#354F38]/20 pointer-events-none z-50 inline-flex items-center justify-center gap-1.5 backdrop-blur-sm">
          <div className="w-1.5 h-1.5 rounded-full bg-[#354F38] animate-pulse" />
          <span className="text-[11px] font-black tracking-wide text-[#354F38]">배치 수정 모드</span>
        </div>
      )}
    </div>
  );
}
